module.exports = __webpack_public_path__ + "static/magic_missile-135d979ba6013d375613eb0aed51257a.jpg";